/**
 * Cart page — auto-update koszyka na zmianę ilości produktu.
 *
 * WC default wymaga kliku "Aktualizuj koszyk" po zmianie qty. UX problem:
 *  - user zmienia +/- i myśli że to natychmiast działa
 *  - cena/total nie zmienia się dopóki nie kliknie
 *
 * Fix: debounced auto-submit `name="update_cart"` button po 700ms od zmiany qty.
 *  - Full page POST (zachowuje wszystkie WC hooki, plugin compat)
 *  - Lekki flash przy reloadzie jest OK — WC standard behavior dla cart
 *  - "Aktualizuj koszyk" link i tak zostaje jako fallback (np. kupon)
 */
export function initCartQtyLive() {
    const form = document.querySelector('form.woocommerce-cart-form, form.hn-cart__form');
    if (!form) return;

    let timer = null;

    const triggerUpdate = () => {
        const btn = form.querySelector('button[name="update_cart"], input[name="update_cart"]');
        if (!btn) return;
        // Enable button (WC disabluje go domyślnie do czasu pierwszej zmiany qty).
        btn.disabled = false;
        btn.click();
    };

    form.addEventListener('change', (e) => {
        const t = e.target;
        if (!t || t.type !== 'number') return;
        // Match input name=`cart[KEY][qty]` (WC standard) lub `cart[…][qty]`.
        if (!t.name || t.name.indexOf('cart[') !== 0 || t.name.indexOf('[qty]') === -1) return;
        clearTimeout(timer);
        timer = setTimeout(triggerUpdate, 700);
    });

    // Klik na -/+ buttony WC quantity-input fire'uje `change` na input — pokryte przez handler powyżej.
    // Plus listener na 'input' żeby debounce zaczął się też przy ręcznym wpisywaniu.
    form.addEventListener('input', (e) => {
        const t = e.target;
        if (!t || t.type !== 'number') return;
        if (!t.name || t.name.indexOf('cart[') !== 0 || t.name.indexOf('[qty]') === -1) return;
        clearTimeout(timer);
        timer = setTimeout(triggerUpdate, 900);
    });
}
